module.exports = __webpack_public_path__ + "media/src/assets/images/amenities_blue/tv-8fd2e468b7b5343a89abb8c2d05ca5ce.svg";